import { render, staticRenderFns } from "./CampaignsTableView.vue?vue&type=template&id=a64a53f6&scoped=true&"
import script from "./CampaignsTableView.vue?vue&type=script&lang=ts&"
export * from "./CampaignsTableView.vue?vue&type=script&lang=ts&"
import style0 from "./CampaignsTableView.vue?vue&type=style&index=0&id=a64a53f6&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a64a53f6",
  null
  
)

export default component.exports